import React from "react"
import { photoChangeMessage } from "./customerFormBaseline.js"

/**
 * Inline hint next to a field label when the value differs from the loaded customer baseline.
 * @param {{
 *   fromDisplay: string,
 *   kind?: string,
 *   onUndo?: () => void,
 *   applyLabel?: string,
 *   onApply?: () => void,
 * }} props
 */
export function FieldChangeHint({ fromDisplay, kind, onUndo, applyLabel, onApply }) {
    const text =
        kind != null && kind.startsWith("photo_") ?
            photoChangeMessage(kind) :
            `Updated from "${fromDisplay}"`

    return (
        <span className="ms-2 fw-normal text-warning-emphasis" style={{ fontSize: "0.8rem" }}>
            {text}{" "}
            <button
                type="button"
                className="btn btn-link btn-sm p-0 align-baseline text-warning-emphasis"
                style={{ textDecoration: "underline", fontSize: "inherit" }}
                onClick={(e) => {
                    e.preventDefault()
                    onUndo?.()
                }}
            >
                Undo
            </button>
            {onApply != null ? (
                <>
                    {" "}
                    <button
                        type="button"
                        className="btn btn-link btn-sm p-0 align-baseline text-warning-emphasis"
                        style={{ textDecoration: "underline", fontSize: "inherit" }}
                        onClick={(e) => {
                            e.preventDefault()
                            onApply()
                        }}
                    >
                        {applyLabel ?? "Apply to contact"}
                    </button>
                </>
            ) : null}
        </span>
    )
}
